import { ReactNode, createContext, useContext } from "react";
import { useFilterService } from "./filter-service.hook";

const FilterServiceContext = createContext(
  {} as ReturnType<typeof useFilterService>
);
export function useFilterServiceContext() {
  return useContext(FilterServiceContext);
}

interface FilterServiceProviderProps {
  children: ReactNode;
}
export function FilterServiceProvider({
  children,
}: FilterServiceProviderProps) {
  return (
    <FilterServiceContext.Provider value={useFilterService()}>
      {children}
    </FilterServiceContext.Provider>
  );
}